import { formatCurrency } from '../../../formatters'

export const renderPrincipalColumn = (principal: number) => formatCurrency({ value: principal })
